import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'
import history from '../../lib/history'
import { establishSession, WEB_SESSION_HEADERS } from '../../lib/webSession'
import {
  ACCOUNT_LOCKED_MESSAGE,
  ACCOUNT_LOCKED_REASON,
  ACCOUNT_LOCKED_STATUS,
  PASSWORD_BLOCK_REASONS,
  PASSWORD_CHANGE_STATUS,
  remainingAttemptsOf,
} from '../../lib/passwordPolicy'

const asyncLocalStorage = {
  setItem: function(key, value) {
    return Promise.resolve().then(function() {
      localStorage.setItem(key, value)
    })
  },
  getItem: function(key) {
    return Promise.resolve().then(function() {
      return localStorage.getItem(key)
    })
  },
}

function* checkLogin(action) {
  const {
    credentials: { username, password, loginType, userType, jwt, truckNo, cb },
  } = action.payload

  try {
    var url = ''
    let body = null
    if (
      action.payload.credentials.token != '' &&
      action.payload.credentials.token != undefined &&
      action.payload.credentials.token != null
    ) {
      url = `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/auth/login-by-token`
      body = { token: action.payload.credentials.token }
    } else {
      url = `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/auth/checkuser`
      if (loginType == 'bluenet-via-url') {
        url = `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/auth/checkuser-bluenet-via-url`
      } else if (loginType == 'bluenet') {
        url = `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/bluenet/curl-authen`
        if (userType == 'New')
          url = `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/auth/checkuser-by-pattern`
      }
      body = {
        username,
        password,
        loginType,
        userType,
        jwt,
        appId: 1,
      }
    }

    // every url here is the Laravel API — opt in to the web session (30 min + refresh token)
    const res = yield call(axios.post, url, body, { headers: WEB_SESSION_HEADERS })
    let {
      data: {
        token,
        permissions,
        vehicle_list,
        location_list,
        material_list,
        exactly_location,
        mill_location_list,
        plant_location_list,
        is_mill,
        is_plant,
        vehicle_group_list,
        location_group_list,
        config,
        data_visibility_node,
        org_chart_vehicle_visibility,
        org_chart,
        user_history_logon_id,
        relate_company,
        web_login_redirect,
        is_bluenet_user,
        refresh_token,
      },
    } = res
    // keep the login's refresh token, or trade the token for a web session (30 min + refresh)
    token = yield call(establishSession, token, refresh_token)
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let deToken = JSON.parse(window.atob(base64))

    yield call(() =>
      actions.storeCredentials(
        token,
        deToken,
        permissions,
        vehicle_list,
        location_list,
        material_list,
        exactly_location,
        mill_location_list,
        plant_location_list,
        is_mill,
        is_plant,
        vehicle_group_list,
        location_group_list,
        config,
        data_visibility_node,
        org_chart_vehicle_visibility,
        org_chart,
        user_history_logon_id,
        relate_company,
        web_login_redirect,
        is_bluenet_user
      )
    )
    yield put(
      actions.checkLogin.success(
        token,
        deToken,
        permissions,
        vehicle_list,
        location_list,
        material_list,
        exactly_location,
        mill_location_list,
        plant_location_list,
        is_mill,
        is_plant,
        vehicle_group_list,
        location_group_list,
        config,
        data_visibility_node,
        org_chart_vehicle_visibility,
        org_chart,
        user_history_logon_id,
        relate_company,
        web_login_redirect,
        is_bluenet_user,
        cb
      )
    )

    // loginType == "bluenet-via-url" && cb();
  } catch (err) {
    // password policy (TECH_SPEC §3.1): 403 + reason, no token → forced change view
    if (
      err.response &&
      err.response.status === 403 &&
      err.response.data &&
      PASSWORD_BLOCK_REASONS.indexOf(err.response.data.error) !== -1
    ) {
      yield put(
        actions.checkLogin.failure(
          PASSWORD_CHANGE_STATUS,
          err.response.data.msg,
          err.response.data.error
        )
      )
      return
    }
    // account lockout: 403 account_locked → the login page swaps the form for the
    // "account locked" view (not the forced-change view — changing the password
    // does not unlock)
    if (
      err.response &&
      err.response.status === 403 &&
      err.response.data &&
      err.response.data.error === ACCOUNT_LOCKED_REASON
    ) {
      yield put(
        actions.checkLogin.failure(
          ACCOUNT_LOCKED_STATUS,
          err.response.data.msg || ACCOUNT_LOCKED_MESSAGE,
          ''
        )
      )
      return
    }
    if (err.response && err.response.status == 500) {
      //Laravel API error
      yield put(
        actions.checkLogin.failure('error', 'Internal Server Error!', '')
      )
      return
    }

    // error from bluenet
    const error = err.response.data.error.toLowerCase()
    let err_msg = ''
    if (error == 'invalid.credentials.bluenet') {
      err_msg = err.response.data.msg.toLowerCase()
    }
    if (err.message.indexOf('400') !== -1)
      yield put(
        actions.checkLogin.failure(
          'error',
          'Invalid username or password!',
          err_msg,
          remainingAttemptsOf(err.response)
        )
      )
    else if (err.message.indexOf('401') !== -1)
      yield put(actions.checkLogin.failure('error', 'Account expired!', ''))
    else if (err.message.indexOf('500') !== -1)
      yield put(
        actions.checkLogin.failure(
          'error',
          'Internal Bluenet Server Error!',
          ''
        )
      )
    else if (err.message.indexOf('503') !== -1)
      yield put(actions.checkLogin.failure('error', 'Service Unavailable!', ''))
    else if (err.message.indexOf('502') !== -1)
      yield put(actions.checkLogin.failure('error', 'Bad Gateway!', ''))
    else if (err.message.indexOf('504') !== -1)
      yield put(actions.checkLogin.failure('error', 'Gateway Timeout!', ''))
    else
      yield put(
        actions.checkLogin.failure('error', 'Something went wrong!', '')
      )
  }
}

function* loadFavoriteMenu(action) {
  const {
    data: { userId, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/favorite/get?user_id=${userId}`,
      // `http://booking-api/api/customer`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.loadFavoriteMenu.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadFavoriteMenu.failure())
  }
}

function* createFavoriteMenu(action) {
  const {
    data: { matchingName, path, userId, accessToken },
    cb,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/favorite/add`,
      {
        matchingName,
        path,
        userId,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    cb()
    yield put(actions.createFavoriteMenu.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.createFavoriteMenu.failure())
  }
}

function* deleteFavoriteMenu(action) {
  const {
    data: { userId, favId, accessToken },
    cb,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/favorite/delete`,
      {
        fav_id: favId,
        user_id: userId,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    cb()
    yield put(actions.deleteFavoriteMenu.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.deleteFavoriteMenu.failure())
  }
}

export default function* watchAuthState() {
  yield all([
    takeEvery(actions.CHECK_LOGIN.REQUEST, checkLogin),
    takeEvery(actions.LOAD_FAVORITE_MENU.REQUEST, loadFavoriteMenu),
    takeEvery(actions.CREATE_FAVORITE_MENU.REQUEST, createFavoriteMenu),
    takeEvery(actions.DELETE_FAVORITE_MENU.REQUEST, deleteFavoriteMenu),
  ])
}

export { checkLogin, loadFavoriteMenu, createFavoriteMenu, deleteFavoriteMenu }
